import { render, staticRenderFns } from "./RecoverPasswordPage.vue?vue&type=template&id=7f23d6a3&scoped=true"
import script from "./RecoverPasswordPage.vue?vue&type=script&lang=js"
export * from "./RecoverPasswordPage.vue?vue&type=script&lang=js"
import style0 from "./RecoverPasswordPage.vue?vue&type=style&index=0&id=7f23d6a3&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f23d6a3",
  null
  
)

export default component.exports